<template>
  <billing-report-panel
    report-key="batches-competence"
    route="/reports/billing-batches-competence"
    file-name="lotes-por-competencia.xlsx"
    period-label="Período de fechamento do lote"
    :columns="columns"
    show-status
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Competência',
        'Lote',
        'Tipo de guia',
        'Guias',
        'Itens',
        'Valor informado',
        'Situação',
        'Fechado em',
        'Enviado em',
        'Subtotal por convênio',
      ],
    };
  },
};
</script>
